import React from 'react';
import NotesSummaryCard from '../TextSummaryCard/NotesSummaryCard';
import styles from './StudentNotesSummaryPanel.module.css';

interface StudentNotesSummaryPanelProps {
  value?: string | null;
}

const StudentNotesSummaryPanel: React.FC<StudentNotesSummaryPanelProps> = ({
  value,
}) => (
  <div className={styles.summarySection}>
    <NotesSummaryCard value={value} scrollable />
  </div>
);

export default StudentNotesSummaryPanel;
